import { LanguageEnum } from './../../shared/models/item.model';
import { PlatformFaqModel } from './../model/platform-faq.model';
import { PlatformFaqService } from './../service/platform-faq.service';
import { Component, OnInit } from '@angular/core';
import { LanguageService } from 'src/app/services/language.service';
import { IdentityService } from 'src/app/@core/services/identity.service';

@Component({
  selector: 'app-platform-faq',
  templateUrl: './platform-faq.component.html',
  styleUrls: ['./platform-faq.component.scss'],
})
export class PlatformFaqComponent implements OnInit {
  isRTL: boolean;
  languageId: number = 2;
  platformFaqs: PlatformFaqModel[];
  activeIds = 'acc-1';
  /** The request has come back - used to tell "loading" from "nothing published". */
  loaded: boolean = false;

  constructor(private platformFaqService: PlatformFaqService, private languageService: LanguageService,
    private identityService: IdentityService) { }

  get isUnified(): boolean {
    return this.identityService.isUnifiedCode();
  }

  ngOnInit() {
    this.onLangaugeChange();
    if (this.languageService.getCurrentLanguage() === LanguageEnum.ar)
    {
      this.languageId = 2;
      this.loadFaqsByLanguageId(this.languageId);
    } else {
      this.languageId = 1;
      this.loadFaqsByLanguageId(this.languageId);
      }
  }

  onLangaugeChange()
  {
    this.languageService.languageChange.subscribe(res =>
      {
        this.isRTL = res === LanguageEnum.ar;
        if (!this.isRTL) { this.languageId = 1; } else { this.languageId = 2};
      this.loadFaqsByLanguageId(this.languageId);
      });
  }

  loadFaqsByLanguageId(id: number)
  {
    this.loaded = false;
    return this.platformFaqService.getAllPlatformFaqsbyLanguageId(id).subscribe({
      next: (faqs: any) => (this.platformFaqs = faqs ?? []),
      error: () => {
        this.platformFaqs = [];
        this.loaded = true;
      },
      complete: () => (this.loaded = true),
      });
  }
}
